'use strict';

var pageTracking = require('./pageTracking');
var configureSaveBuildFormComplete = require('./configureSaveBuild');
var financeEvents = require('./financeEvents');
var brochureEvents = require('./brochureEvents');
var testDriveEvents = require('./testDriveEvents');
var locationEvents = require('./locationEvents');
var configuratorEvents = require('./configuratorEvents');
var locationTriggerSource = null;

window.addEventListener('load', function () {
    $(document).ready(function () {
        //ensure the dataLayer is instantiated
        window.dataLayer = window.dataLayer || [];

        pageTracking.init();

        $('body').on('gtm:event', function (e, info) {
            var data = info.data;
            var callbackFunction = info.callback;

            // push the event
            if (typeof window.dataLayer !== 'undefined' && callbackFunction) {
                events[callbackFunction](data);
            }
        });

        $('body').on('click', '.faq-header', function () {
            $('body').trigger('gtm:event', {
                callback: 'clickAccordion',
                data: $(this)
            });
        });

        $('body').on('click', '.nav-link.dropdown-toggle, .dropdown-link', function () {
            if (document.querySelector('.configurator-navigation')) return;
            $('body').trigger('gtm:event', {
                callback: 'headerClick',
                data: $(this)
            });
        });

        $('a.btn-title').click(function (event) {
            $('body').trigger('gtm:event', {
                callback: 'viewShowroom',
                data: $(this)
            });
        });

        $('body').on('click', '.car-model-button', function () {
            if ($(this).find('.btn__label').text().trim() === "Build") {
                $('body').trigger('gtm:event', {
                    callback: 'buildMyCar',
                    data: $(this)
                });
            }
        });

        $('body').on('click', '.sidebar-edit-location', function () {
            let isSidebar = $(this).parents('#sidebarLocation').length ? 'sidebar' : 'page';
            if (isSidebar == 'sidebar') {
                $('body').trigger('gtm:event', {
                    callback: 'sidebarEditLocation',
                    data: $(this),
                });
            } else {
                $('body').trigger('gtm:event', {
                    callback: 'editLocation',
                    data: $(this)
                });
            }
        });

        $('body').on('click', '#sidebar-useMyLocation', function () {
            let isSidebar = $(this).parents('#sidebarLocation').length ? 'sidebar' : 'page';
            if (isSidebar == 'sidebar') {
                $('body').trigger('gtm:event', {
                    callback: 'sidebarUseMyCurrentLocation',
                    data: $(this)
                });
            } else {
                $('body').trigger('gtm:event', {
                    callback: 'useMyCurrentLocation',
                    data: $(this)
                });
            }
        });

        $('body').on('click', '#sidebar-configurator-google-autocomplete', function () {
            locationTriggerSource = $(this);
        });

        $('body').on('location:afterUpdate', function () {
            let isSidebar = locationTriggerSource && locationTriggerSource.parents('#sidebarLocation').length ? 'sidebar' : 'page';
            if ($('.configurator-footer').length === 0) {
                if (isSidebar === 'sidebar') {
                    $('body').trigger('gtm:event', {
                        callback: 'sidebarLocationPinEntered',
                        data: $(this)
                    });
                } else {
                    $('body').trigger('gtm:event', {
                        callback: 'locationPinEntered',
                        data: $(this)
                    });
                }
            }
            locationTriggerSource = null;
        });

        $('body').on('click', '#configurator-footer-actions-select-location', function () {
            $('body').trigger('gtm:event', {
                callback: 'editConfiguratorLocation',
                data: $(this)
            });
        });

        $('body').on('click', '#configurator-useMyLocation', function () {
            $('body').trigger('gtm:event', {
                callback: 'configuratorUseMyLocation',
                data: $(this)
            });
        });

        $('body').on('click', '#configurator-location-confirm', function () {
            $('body').trigger('gtm:event', {
                callback: 'configuratorLocationPinEntered',
                data: $(this)
            });
        });

        $('body').on('click', '#configurator-footer-actions-save', function () {
            setTimeout(() => {
                $('body').trigger('gtm:event', {
                    callback: 'configuratorSaveAndShare',
                    data: $(this)
                });
            }, 2000);
        });

        $('body').on('click', '#configurator-footer-actions-summary', function () {
            $('body').trigger('gtm:event', {
                callback: 'configuratorSummary',
                data: $(this)
            });
        });

        // Footer/summary reads inside configuratorbookATestDrive are populated by the initial
        // product select, which always completes before this CTA is interactive — no delay needed.
        $('body').on('click', '.btn-test-drive', function () {
            $('body').trigger('gtm:event', {
                callback: 'configuratorbookATestDrive',
                data: $(this)
            });
        });

        $('body').on('click', '#accord-test-drive, #hrv-take-test-drive', function () {
            $('body').trigger('gtm:event', {
                callback: 'accordTestDrive',
                data: $(this)
            });
        });

        $('body').on('click', '#view-spec-sheet', function () {
            $('body').trigger('gtm:event', {
                callback: 'accordSpecSheet',
                data: $(this)
            });
        });

        $('body').on('click', '.header-search.nav-item', function () {
            $('body').trigger('gtm:event', {
                callback: 'headerSearch',
                data: $(this)
            });
        });

        $('body').on('click', '.user.text-white.nav-item', function () {
            $('body').trigger('gtm:event', {
                callback: 'customerLogin',
                data: $(this)
            });
        });

        $('body').on('click', '#side-navigation-menu-location', function () {
            $('body').trigger('gtm:event', {
                callback: 'menuLocation',
                data: $(this)
            });
        });

        // NOTE: sidebarDownloadBrochure and sidebarSelectAModel
        // click bindings are owned by brochureEvents.init() — do not duplicate here.

        $('body').on('click', '#sidebar-selected-model', function () {
            $('body').trigger('gtm:event', {
                callback: 'sidebarSelectedModel',
                data: $(this)
            });
        });

        $('body').on('click', '#sidebar-testDrive', function () {
            $('body').trigger('gtm:event', {
                callback: 'sidebarTestDrive',
                data: $(this)
            });
        });

        $('body').on('click', '#sidebar-testDrive-select-model', function () {
            $('body').trigger('gtm:event', {
                callback: 'testDriveSelectModel',
                data: $(this)
            });
        });

        $('body').on('click', '#sidebar-testDrive-selected-model', function () {
            $('body').trigger('gtm:event', {
                callback: 'testDriveSelectedModel',
                data: $(this)
            });
        });

        $('body').on('click', '.configurator-specs__view-all-btn', function () {
            $('body').trigger('gtm:event', {
                callback: 'viewKeyFeatures',
                data: $(this)
            });
        });

        $('body').on('click', '.configurator__keySpec-download-btn', function () {
            $('body').trigger('gtm:event', {
                callback: 'downloadSpecSheet',
                data: $(this)
            });
        });

        $('body').on('click', '#sidebar-find-hondaCenter', function () {
            $('body').trigger('gtm:event', {
                callback: 'sidebarFindHondaCenter',
                data: $(this)
            });
        });

        // ── Finance events — see financeEvents.js ──────────────────────────────
        financeEvents.init();

        // ── Brochure events — see brochureEvents.js ─────────────────────────────
        brochureEvents.init();
        testDriveEvents.init();

        $('body').on('click', '#sidebar-book-service', function () {
            $('body').trigger('gtm:event', {
                callback: 'sidebarBookService',
                data: $(this)
            });
        });

        $('body').on('click', '#configurator-save-and-share', function () {
            $('body').trigger('gtm:event', {
                callback: 'configureSaveBuildFormStart',
                data: false
            });
        });

        // NOTE: configureTestDriveFormStart is now called directly from configuratorbookATestDrive
        // after the view push — do not bind to the form element here.

        // Test Drive Flyout step reached — Confirm Honda Centre / Shopper Details only.
        document.body.addEventListener('amb:modal-view-changed', function (event) {
            var view = event.detail && event.detail.view;

            if (view !== 'test-drive-honda-centre' && view !== 'test-drive-details') {
                return;
            }

            $('body').trigger('gtm:event', {
                callback: 'testDriveStepReached',
                data: view
            });
        });

        // Brochure Flyout form_view — fires when the redesign "view-brochure" form becomes visible
        // (not on page load). Also wires start/interaction inside the handler. See brochureEvents.js.
        document.body.addEventListener('amb:modal-view-changed', function (event) {
            if (event.detail && event.detail.view === 'view-brochure') {
                $('body').trigger('gtm:event', {
                    callback: 'configuratorViewBrochureForm',
                    data: null
                });
            }
        });

        $('body').on('click', '.sidebar-car-selector', function () {
            $('body').trigger('gtm:event', {
                callback: 'selectModelsidebar',
                data: $(this)
            });
        });

        $('body').on('click', '#selectCarModelBtn', function () {
            $('body').trigger('gtm:event', {
                callback: 'selectModel',
                data: $(this)
            });
        });

        $('body').on('click', '#buildAndPriceCTA', function () {
            $('body').trigger('gtm:event', {
                callback: 'buildAndPrice',
                data: $(this)
            });
        });

        $('body').on('click', '#viewCarCTA', function () {
            $('body').trigger('gtm:event', {
                callback: 'viewCarDetails',
                data: $(this)
            });
        });

        $('body').on('click', '#addExistingHondaCTA', function () {
            $('body').trigger('gtm:event', {
                callback: 'addExistingHondaCTA',
                data: $(this)
            });
        });

        $('body').on('click', '#bookServiceCTA', function () {
            $('body').trigger('gtm:event', {
                callback: 'bookServiceCTA',
                data: $(this)
            });
        });

        $('body').on('click', '.experience-commerce_assets-rangeFAQs', function () {
            var clicked = $(this);
            var collapseDiv = clicked.find('.collapse');
            if (!collapseDiv.hasClass('show')) {
                var clickedQuestion = this.innerText.trim();
                var urlPath = window.location.href;
                var url = urlPath.split('/').pop();
                var categoryName = url.split('.')[0];
                dataLayer.push({
                    event: "custom.accordion",
                    group: "accordian",
                    category: categoryName + ' car page',
                    action: "click",
                    label: clickedQuestion
                });
            }
        });

        $('body').on('click', '.nav-link#offers', function (e) {
            if (document.querySelector('.configurator-navigation')) return;
            e.preventDefault();
            dataLayer.push({
                'event': 'custom.menu',
                'group': 'header-submenu',
                'action': 'click',
                'name': 'offers',
                'category': "home page",
                'label': 'Offers'
            });
            var url = $(this).attr('href');
            window.location.href = url;
        });

        $('body').on('my.honda.document.downloaded', function (elm, params) {
            var pageType = window.location.pathname.split('/').pop();
            var modelName = $('input[name="modelName"]').val();
            dataLayer.push({
                event: "custom.cta",
                group: "account",
                category: pageType,
                action: "download - " + params.doctype,
                label: params.docid + ' - ' + modelName,

            });
        });

        $('body').on('click', '.order-detail-document__request-cta', function () {
            var pageType = window.location.pathname.split('/').pop();
            var ctaText = $(this).find('.actions-link').text().trim();
            dataLayer.push({
                event: "custom.cta",
                group: "account",
                category: pageType,
                action: "click",
                label: ctaText + " - purchase"
            });
        });

        $('body').on('click', '.order-detail-service__summary-cta', function () {
            var pageType = window.location.pathname.split('/').pop();
            var ctaText = $(this).text().trim();
            var modelName = $(this)
                .closest('.garage-card')
                .find('.sub-title-xl')
                .clone()
                .children().remove()
                .end()
                .text().trim();

            var label = "view - " + ctaText;
            if (modelName) {
                label += " - " + modelName;
            }

            dataLayer.push({
                event: "custom.cta",
                group: "account",
                category: pageType,
                action: "click",
                label: label
            });
        });


        $('.jumbotron-banner__actions').on('click', 'a', function (e) {
            e.preventDefault();
            var clickedText = $(this).text().trim();
            var clickedHref = $(this).attr('href');
            var modelText = '';

            if (document.querySelector('div.storepage#homepage')) {
                modelText = 'Home Page';
            } else {
                modelText = 'Showroom Page';
            }

            dataLayer.push({
                event: "custom.cta",
                group: "hero",
                category: modelText,
                action: "click",
                label: clickedText
            });
            window.location.href = clickedHref;
        });

        $('body').on('product:afterAddToCart', function (ele, data) {
            window.dataLayer.push(data.dataLayerObj);
        });

        $('body').on('click', '#finalise-owner-details, .finalise-account-btn', function () {
            var pageType = window.location.pathname.split('/').pop();

            dataLayer.push({
                event: "custom.cta",
                group: 'account',
                category: pageType,
                action: "click",
                label: "Finalise owner details"
            });
        });


        $('body').on('click', '#add-owner-btn', function () {
            var pageType = window.location.pathname.split('/').pop();
            dataLayer.push({
                event: "custom.cta",
                group: "account",
                category: pageType + " - Finalise owner details ",
                action: "click",
                label: pageType + " - Add secondary owner"

            });
        });

        $('body').on('click', '#add-registered-owner-btn', function () {
            var pageType = window.location.pathname.split('/').pop();
            dataLayer.push({
                event: "custom.cta",
                group: "account",
                category: pageType + " - Finalise owner details ",
                action: "click",
                label: pageType + " - Add registered owner"

            });
        });

        $('body').on('click', '.order-detail-modify-accessories, .order-detail-modify-car', function () {
            $('body').trigger('gtm:event', {
                callback: 'modifyAccessories',
                data: $(this)
            });
        });

        $('body').on('click', '#modify-car-update-button', function () {
            $('body').trigger('gtm:event', {
                callback: 'configUpdateOrder',
                data: $(this)
            });
        });

        $('body').on('product:afterAttributeSelect', function (el, response) {
            if (response.data.product.productType !== "master") {
                setTimeout(() => {
                    $('body').trigger('gtm:event', {
                        callback: 'configuratorProductData',
                    });
                }, 3000);
            }
        });

        $(function () {
            var $currentProduct = $('#current-product');
            var summaryDataJSON = $('.js-save-summary').attr('data-car-summary-data');

            if ($currentProduct.length && $currentProduct.data('producttype') !== 'master' && summaryDataJSON && (!$currentProduct.attr('data-gtm-default-view-item-pushed'))) {
                $('body').trigger('gtm:event', {
                    callback: 'configuratorProductData',
                });
                $currentProduct.attr('data-gtm-default-view-item-pushed', true);
            }
        });
    });

    var events = {
        configuratorProductData: function () {
            var summaryDataJSON = $('.js-save-summary').attr('data-car-summary-data');

            // First HTML leaves this empty; Product-Variation writes it on afterAttributeSelect.
            if (!summaryDataJSON) {
                return;
            }

            var summaryData = JSON.parse(summaryDataJSON);
            var productData = summaryData.data.product;

            var spanText = document.getElementById('configurator-footer-location-summary')?.textContent.trim() || '';
            var locationPostCode = '';
            var match = spanText.match(/(\d{4})$/);
            if (match) {
                locationPostCode = match[1];
            }
            var dealerName = document.getElementById('configurator-footer-dealer-name')?.textContent.trim() || '';

            var item = {
                item_name: productData.productName || '',
                item_id: productData.id,
                item_brand: productData.brand || 'Honda',
                item_category: productData.customProps.grade,
                item_category2: productData.customProps.FullYear,
                item_category3: productData.customProps.JapaneseModelCode,
                item_category4: productData.customProps.Model,
                item_category5: dealerName,
                item_variant: productData.customProps.ColorDesc,
                price: productData.customProps.BasePrice,
                coupon: "",
                discount: productData.customProps.BasePrice && productData.customProps.DriveAwayPrice
                    ? Math.max(0, parseFloat(productData.customProps.BasePrice) - parseFloat(productData.customProps.DriveAwayPrice))
                    : (productData.customProps.discount != null ? productData.customProps.discount : null),
                quantity: 1,
                location_id: locationPostCode
            };

            var items = [item];

            var ecommerceData = {
                currency: "AUD",
                value: productData.customProps.BasePrice,
                items: items
            };

            dataLayer.push({
                event: "view_item",
                ecommerce: ecommerceData
            });
        },

        clickAccordion: function (data) {
            var faqText = data.find('.header-text').text().trim();
            var currentUrl = window.location.href;
            var rangeType = currentUrl.split('/').pop().replace('.html', '').toLowerCase();
            dataLayer.push({
                'event': 'custom.accordion',
                'group': 'accordian',
                'action': "click",
                'category': rangeType + ' page',
                'label': faqText
            });
        },

        selectModelsidebar: function (data) {
            var modelname = data.closest('.car-card').find('.car-model-name').text().trim();
            dataLayer.push({
                'event': 'custom.model',
                'group': 'select model',
                'category': "side navigation",
                'action': "click",
                'label': modelname
            });
        },

        headerClick: function (data) {
            var linkText = data.closest('.dropdown').find('.dropdown-toggle').text().trim();
            var groupType = data.hasClass('dropdown-toggle') ? 'header' : 'header- submenu';
            var name = data.text().trim();

            if (linkText == 'Cars') {
                dataLayer.push({
                    'event': 'custom.menu',
                    'group': groupType,
                    'action': 'click',
                    'category': "home page",
                    'label': 'models'
                });
            } else {
                dataLayer.push({
                    'event': 'custom.menu',
                    'group': groupType,
                    'action': 'click',
                    'name': name,
                    'category': "home page",
                    'label': linkText
                });
            }
        },

        viewShowroom: function (data) {
            var location = data.closest('.showroom-card').find('.title').text();
            var currentUrl = window.location.href;
            var cleanUrl = currentUrl.split('?')[0];
            var rangeType = cleanUrl.split('/').pop().replace('.html', '').toLowerCase();
            dataLayer.push({
                'event': 'custom.cta',
                'action': "click",
                'group': 'blocks',
                'category': rangeType + ' page',
                'label': data.text()
            });
            dataLayer.push({
                event: "custom.model",
                group: "select model",
                category: rangeType + ' page', //dynamically pass the page from where they select or click CTA.
                action: "click",
                label: data.text().replace('Build your ', '') ////dynamically pass the model name
            });
        },

        buildMyCar: function (data) {
            var currentUrl = window.location.href;
            var modelName = data.closest('.car-card').find('.car-model-name').text().trim();
            var cleanUrl = currentUrl.split('?')[0];
            var rangeType = cleanUrl.split('/').pop().split('#')[0].replace('.html', '').toLowerCase();
            var currentPath = window.location.pathname.toLowerCase();
            var pageName = currentPath.includes('home') ? rangeType : modelName;
            dataLayer.push({
                'event': 'custom.cta',
                'action': "click",
                'group': 'blocks',
                'category': "home page",
                'label': "Build my " + modelName
            });
            dataLayer.push({
                'event': "custom.model",
                'group': "select model",
                'category': "home page",
                'action': "click",
                'label': modelName
            });
        },
        selectModel: function (data) {
            var ctaText = data.text().trim();
            var modelText = '';
            var carName = ctaText.replace('Build ', '').replace('Your ', '').replace('your ', '');

            if (document.querySelector('div.storepage#homepage')) {
                modelText = 'Home Page';
            } else {
                modelText = ' Showroom Page';
            }
            dataLayer.push({
                'event': 'custom.list',
                'action': "click",
                'group': 'select your model',
                'category': carName + modelText,
                'label': ctaText
            });
            dataLayer.push({
                'event': "custom.model",
                'group': "select your model",
                'category': carName + modelText,
                'action': "click",
                'label': carName
            });
            dataLayer.push({
                'event': 'custom.cta',
                'action': "click",
                'group': 'Hero',
                'category': carName + modelText,
                'label': ctaText
            });
        },

        buildAndPrice: function (data) {
            var currentUrl = window.location.href;
            var cleanUrl = currentUrl.split('?')[0];
            var rangeType = cleanUrl.split('/').pop().replace('.html', '').toLowerCase();
            var buttonText = data.text().trim();
            dataLayer.push({
                'event': 'custom.cta',
                'action': "click",
                'group': 'blocks',
                'category': rangeType + ' page',
                'label': buttonText
            });
        },
        viewCarDetails: function (data) {
            var safetyRecallHeading = document.querySelector('.safety-recall-heading');
            var safetyRecallText = safetyRecallHeading ? safetyRecallHeading.textContent.trim().toLowerCase() : 'safety recall';

            let $card = data.closest('.garage-card');
            let modelName = $card.find('.garage-card-modelname').text().trim();

            let buttonText = data.find('.btn__label').text().trim();
            var isRecall = data.data('is-recall');

            var labelText = 'New Car';
            if (isRecall === true) {
                labelText = safetyRecallText;
            } else if (isRecall === false) {
                labelText = 'Existing Car';
            }

            window.dataLayer = window.dataLayer || [];
            dataLayer.push({
                event: 'custom.cta',
                action: 'click',
                group: 'account',
                category: 'My Garage',
                label: buttonText + ' - ' + modelName + ' - ' + labelText
            });
        },
        bookServiceCTA: function (data) {
            var isRecall = data.data('is-recall')
            var safetyRecallHeading = document.querySelector('.safety-recall-heading');
            var safetyRecallText = safetyRecallHeading ? safetyRecallHeading.textContent.trim().toLowerCase() : 'safety recall';
            var modelName = data.closest('.garage-card-container').find('.garage-card-modelname').text();
            let buttonText = data.find('.btn__label').text().trim();
            var labelText = '';
            if (isRecall) {
                labelText = safetyRecallText;
            } else {
                labelText = 'Services';
            }
            dataLayer.push({
                'event': 'custom.cta',
                'action': "click",
                'group': 'account',
                'category': 'My Garage',
                'label': buttonText + ' - ' + modelName + ' - ' + labelText
            });
        },
        addExistingHondaCTA: function (data) {
            var buttonText = data.text().trim();
            dataLayer.push({
                'event': 'custom.cta',
                'action': "click",
                'group': 'account',
                'category': 'My Garage',
                'label': buttonText
            });
        },
        sendDetailToHonda: function (data) {
            if (data && data.order) {
                var requestNovatedQuote = data.order.billing.billingAddress.address.requestNovatedQuote;
                var buttonText = requestNovatedQuote ? "Send my build to Honda" : "Return to the build summary";
                var selectedModels = [];
                var city = data.order.shipping[0].shippingAddress.city;
                var postalCode = data.order.shipping[0].shippingAddress.postalCode;
                var dealerName = data.order.shipping[0].shippingAddress.firstName;
                var accessoriesData = [];
                data.order.items.items.slice(1).forEach(item => {
                    var accesoriesObj = {
                        accessory_id: item.id || '',
                        accessory_name: item.productName || '',
                        accessory_category: item.category || '',
                        accessory_sub_category: item.subcategory || ''
                    }
                    accessoriesData.push(accesoriesObj);
                })
                data.order.items.items.forEach(element => {
                    if (!element.customProps.Model || !element.customProps.body) {
                        return;
                    }
                    var modelObj = {
                        segments: element.customProps.body || '',
                        displayTitle: element.productName || '',
                        title: element.productName || '',
                        code: element.customProps.HesCode || '',
                        sf_model: element.customProps.Model || '',
                        sf_grade: element.customProps.grade || '',
                        sf_door: element.customProps.doors || '',
                        sf_year: element.customProps.Year || '',
                        year: element.customProps.FullYear || '',
                        variants: []
                    };
                    var variantTitle = '';
                    var subVariantTitle = '';
                    if (Array.isArray(element.variationAttributes)) {
                        if (element.variationAttributes[1]) {
                            variantTitle = element.variationAttributes[1].displayValue || '';
                        }
                        if (element.variationAttributes[0]) {
                            subVariantTitle = element.variationAttributes[0].displayValue || '';
                        }
                    }
                    var variantObj = {
                        title: variantTitle,
                        code: element.customProps.HesCode || '',
                        isDefaultVariant: false,
                        transmission: element.customProps.trans || '',
                        sfGrade: element.customProps.grade || '',
                        sfDoor: element.customProps.doors || '',
                        subvariants: []
                    };
                    var subVariantObj = {
                        title: subVariantTitle,
                        exterior_color_code: element.customProps.color || '',
                        colorPrice: "0",
                        polkParams: "_32900_0_0_0_66_1498_1248_6.2_1_1_0_0_4_142",
                        isDefaultSubvariant: true,
                        accesories: accessoriesData ? accessoriesData : []
                    };
                    variantObj.subvariants.push(subVariantObj);
                    modelObj.variants.push(variantObj);
                    selectedModels.push(modelObj);
                });
                dataLayer.push({
                    event: "custom.cta",
                    group: "build",
                    category: "checkout",
                    action: "click",
                    label: buttonText,
                    data: {
                        location: city,
                        postcode: postalCode,
                        dealer: dealerName,
                        leaseoptIn: requestNovatedQuote
                    },
                    models: selectedModels
                });
            }
        },
        selectCarModel: function (data) {
            var buttonText = data.closest('.car-card').find('.car-model-name').text();
            var currentPath = window.location.pathname.toLowerCase();
            var modelName = '';
            var isHome = $('.jumbotron-banner__actions').length > 0;
            if (isHome) {
                modelName = 'home';
            } else {
                modelName = data.closest('.car-card').find('.car-model-name').text();
            }
            dataLayer.push({
                'event': 'custom.list',
                'action': "click",
                'group': 'select your model',
                'category': "side navigation",
                'label': buttonText
            });
            dataLayer.push({
                event: "custom.model",
                group: "select model",
                category: "side navigation",
                action: "click",
                label: buttonText.replace('Build your ', '')
            });
        },
        editLocation: locationEvents.events.editLocation,
        sidebarEditLocation: locationEvents.events.sidebarEditLocation,
        useMyCurrentLocation: locationEvents.events.useMyCurrentLocation,
        sidebarUseMyCurrentLocation: locationEvents.events.sidebarUseMyCurrentLocation,
        locationPinEntered: locationEvents.events.locationPinEntered,
        sidebarLocationPinEntered: locationEvents.events.sidebarLocationPinEntered,
        editConfiguratorLocation: locationEvents.events.editConfiguratorLocation,
        customizeFinanceCTA: financeEvents.events.customizeFinanceCTA,
        applyForFinanceViewForm: financeEvents.events.applyForFinanceViewForm,
        applyForFinanceSubmitForm: financeEvents.events.applyForFinanceSubmitForm,
        configuratorUseMyLocation: locationEvents.events.configuratorUseMyLocation,
        configuratorLocationPinEntered: locationEvents.events.configuratorLocationPinEntered,
        summaryApplyForFinanceForm: financeEvents.events.summaryApplyForFinanceForm,
        summaryApplyForFinance: financeEvents.events.summaryApplyForFinance,
        configuratorFinanceFormView: financeEvents.events.configuratorFinanceFormView,
        configuratorFinanceFormStart: financeEvents.events.configuratorFinanceFormStart,
        configuratorFinanceFormInteraction: financeEvents.events.configuratorFinanceFormInteraction,
        configuratorSaveAndShare: configuratorEvents.events.configuratorSaveAndShare,
        configuratorSummary: configuratorEvents.events.configuratorSummary,
        configuratorbookATestDrive: testDriveEvents.events.configuratorbookATestDrive,
        accordTestDrive: testDriveEvents.events.accordTestDrive,
        accordSpecSheet: configuratorEvents.events.accordSpecSheet,
        headerSearch: function (data) {
            dataLayer.push({
                'event': 'custom.menu',
                'group': 'header',
                'category': 'home page',
                'action': 'click',
                'label': 'search'
            });
        },
        customerLogin: function (data) {
            dataLayer.push({
                'event': 'custom.menu',
                'group': 'header',
                'category': 'home page',
                'action': 'click',
                'label': 'customer portal login'
            });
        },
        menuLocation: locationEvents.events.menuLocation,
        sidebarDownloadBrochure: brochureEvents.events.sidebarDownloadBrochure,
        sidebarSelectAModel: brochureEvents.events.sidebarSelectAModel,
        sidebarSelectedModel: brochureEvents.events.sidebarSelectedModel,
        submitUserDetails: brochureEvents.events.submitUserDetails,
        downloadBrochure: brochureEvents.events.downloadBrochure,
        configuratorViewBrochureForm: brochureEvents.events.configuratorViewBrochureForm,
        configuratorBrochureFormComplete: brochureEvents.events.configuratorBrochureFormComplete,
        sidebarTestDrive: testDriveEvents.events.sidebarTestDrive,
        testDriveSelectModel: testDriveEvents.events.testDriveSelectModel,
        testDriveSelectedModel: testDriveEvents.events.testDriveSelectedModel,
        testDriveUserDetails: testDriveEvents.events.testDriveUserDetails,
        takeTestDrive: testDriveEvents.events.takeTestDrive,
        viewKeyFeatures: configuratorEvents.events.viewKeyFeatures,
        downloadSpecSheet: configuratorEvents.events.downloadSpecSheet,
        sidebarFindHondaCenter: function (data) {
            dataLayer.push({
                'event': 'custom.menu',
                'group': 'side navigation menu',
                'category': 'side navigation',
                'action': 'click',
                'label': data.text().trim()
            });
        },
        sidebarFinanceOptions: financeEvents.events.sidebarFinanceOptions,
        sidebarBookService: function (data) {
            dataLayer.push({
                'event': 'custom.menu',
                'group': 'side navigation menu',
                'category': 'side navigation',
                'action': 'click',
                'label': data.text().trim()
            });
        },
        configureSaveBuildFormStart: configuratorEvents.events.configureSaveBuildFormStart,
        configuratorSaveBuildComplete: configuratorEvents.events.configuratorSaveBuildComplete,
        configureSaveBuildFormComplete: configureSaveBuildFormComplete,
        configureTestDriveFormStart: testDriveEvents.events.configureTestDriveFormStart,
        configureTestDriveFormComplete: testDriveEvents.events.configureTestDriveFormComplete,
        testDriveStepReached: testDriveEvents.events.testDriveStepReached,
        modifyAccessories: function (data) {
            var pageType = window.location.pathname.split('/').pop();
            dataLayer.push({
                'event': 'custom.cta',
                'group': 'Modify order',
                'category': pageType,
                'action': 'click',
                'label': data.text().trim()
            });
        },
        configUpdateOrder: function (data) {
            dataLayer.push({
                'event': 'custom.cta',
                'group': 'Modify order',
                'category': 'configurator',
                'action': 'click',
                'label': data.text().trim()
            });
        }
    };
});
